import axios from "axios";
import { ReconnectingEventSource } from "./ReconnectingEventSource";
import type { DoBotResponse, ForDoBotPayload } from "./types/common";
import type { StreamedAnswerData } from "./types/events";

export class StreamedMessagesReceiver {
  private readonly eventSource: ReconnectingEventSource;
  constructor(
    private readonly analyticsId: string,
    callbacks: {
      receivedAnswerChunk: (messageChunk: string) => void;
      receivedFinalMessage: (finalPayload: DoBotResponse, isInLiveChatMode?: boolean) => void;
      onError: () => void;
    }
  ) {
    const baseUrl = `api/${this.analyticsId}/events`;
    this.eventSource = new ReconnectingEventSource(baseUrl, {
      onMessage: (data: unknown) => {
        if (typeof data !== "string") {
          // eslint-disable-next-line no-console
          console.error("Received data with non-string type");
          return;
        }
        const payload: StreamedAnswerData = JSON.parse(data); //TODO: zod
        if (!payload.isComplete) {
          callbacks.receivedAnswerChunk(payload.messageChunk);
        } else {
          callbacks.receivedFinalMessage(payload.formattedPayload, payload.isInLiveChatMode);
        }
      },
    });
  }

  close() {
    this.eventSource.close();
  }
}

export async function sendQuestionToDoChat(
  doBotUrl: string,
  payload: ForDoBotPayload
): Promise<void> {
  const analyticsSessionId = payload.sender;
  const baseUrl = `/api/${analyticsSessionId}/send?doboturl=${doBotUrl}`;
  await axios.post(baseUrl, payload);
}

export async function sendQuestionToDoBot(
  doBotUrl: string,
  payload: ForDoBotPayload
): Promise<DoBotResponse> {
  const res = await axios.post<DoBotResponse>(doBotUrl, payload);
  return res.data;
}
